export type CapabilityId = 'sell' | 'attract' | 'respond' | 'publish' | 'contacts';

export type Capability = {
  id: CapabilityId;
  label: string;
  href: string;
  subtext: string;
  zones: Array<{ id: string; label: string; href: string }>;
};

export const CAPABILITIES: Capability[] = [
  {
    id: 'sell',
    label: 'Sell',
    href: '/sell',
    subtext: 'Products, offers, pricing',
    zones: [
      { id: 'library', label: 'Library', href: '/sell' },
      { id: 'builder', label: 'Builder', href: '/sell/builder' },
      { id: 'performance', label: 'Performance', href: '/sell/performance' },
    ],
  },
  {
    id: 'attract',
    label: 'Attract',
    href: '/attract',
    subtext: 'Campaigns, hunt mode, segments',
    zones: [
      { id: 'campaigns', label: 'Campaigns', href: '/attract' },
      { id: 'hunt-mode', label: 'Hunt Mode', href: '/attract/hunt-mode' },
      { id: 'segments', label: 'Segments', href: '/attract/segments' },
      { id: 'performance', label: 'Performance', href: '/attract/performance' },
    ],
  },
  {
    id: 'respond',
    label: 'Respond',
    href: '/respond',
    subtext: 'Inbox, contacts, replies',
    zones: [
      { id: 'inbox', label: 'Inbox', href: '/respond' },
      { id: 'contacts', label: 'Contacts', href: '/respond?drawer=contacts' },
      { id: 'composer', label: 'Composer', href: '/composer' },
    ],
  },
  {
    id: 'publish',
    label: 'Publish',
    href: '/publish',
    subtext: 'Posts, articles, calendar',
    zones: [
      { id: 'calendar', label: 'Calendar', href: '/publish' },
      { id: 'drafts', label: 'Drafts', href: '/publish/drafts' },
      { id: 'performance', label: 'Performance', href: '/publish/performance' },
    ],
  },
  {
    id: 'contacts',
    label: 'Contacts',
    href: '/contacts',
    subtext: 'Leads, customers, lists',
    zones: [
      { id: 'all', label: 'All', href: '/contacts' },
      { id: 'leads', label: 'Leads', href: '/contacts/leads' },
      { id: 'customers', label: 'Customers', href: '/contacts/customers' },
      { id: 'inactive', label: 'Inactive', href: '/contacts/inactive' },
      { id: 'lost', label: 'Lost', href: '/contacts/lost' },
    ],
  },
];

export const HUB_SUBTABS = [
  { id: 'today', label: 'Today', href: '/' },
  { id: 'growth', label: 'Growth', href: '/?view=growth' },
  { id: 'project', label: 'Project', href: '/?view=project' },
] as const;

export function findCapabilityByPath(pathname: string): Capability | null {
  if (pathname === '/' || pathname === '/composer') return null;
  for (const cap of CAPABILITIES) {
    if (pathname === cap.href || pathname.startsWith(cap.href + '/')) {
      return cap;
    }
  }
  return null;
}
